import { NgModule } from "@angular/core";
import {
  Routes,
  RouterModule,
  Router,
  NavigationEnd,
  NavigationStart,
} from "@angular/router";
import * as GlobalSubheaderActions from "./store/actions/global-subheader.actions";
import { AppState } from "./store/state/app.state";
import { Store } from "@ngrx/store";

const routes: Routes = [
  {
    path: "home",
    loadChildren: () =>
      import("./home-page/home-page.module").then((mod) => mod.HomePageModule),
  },
  {
    path: "research",
    loadChildren: () =>
      import("./research-grid-page/research-grid-page.module").then(
        (mod) => mod.ResearchGridPageModule,
      ),
  },
  {
    path: "sectors_industries",
    loadChildren: () =>
      import(
        "./sectors-and-industries-page/sectors-and-industries-page.module"
      ).then((mod) => mod.SectorsAndIndustriesPageModule),
  },
  {
    path: "comparative-analysis",
    loadChildren: () =>
      import("./comparative-analysis/comparative-analysis.module").then(
        (mod) => mod.ComparativeAnalysisModule,
      ),
  },
  {
    path: "company",
    loadChildren: () =>
      import("./company-page/company-page.module").then(
        (mod) => mod.CompanyPageModule,
      ),
  },
  {
    path: "reporting",
    loadChildren: () =>
      import("./reporting-pages/reporting-pages.module").then(
        (mod) => mod.ReportingPagesModule,
      ),
  },
  {
    path: "watchlist",
    loadChildren: () =>
      import("./watchlist-page/watchlist-page.module").then(
        (mod) => mod.WatchlistPageModule,
      ),
  },
  {
    path: "mex",
    loadChildren: () =>
      import("./mex-grid-page/mex-grid-page.module").then(
        (mod) => mod.MexGridPageModule,
      ),
  },
  {
    path: "valuation",
    loadChildren: () =>
      import("./valuation-page/valuation-page.module").then(
        (mod) => mod.ValuationPageModule,
      ),
  },
  {
    path: "entitlements",
    loadChildren: () =>
      import("./entitlements/entitlements.module").then(
        (mod) => mod.EntitlementsModule,
      ),
  },
  {
    path: "alert_settings",
    loadChildren: () =>
      import("./alert-settings-page/alert-settings-page.module").then(
        (mod) => mod.AlertSettingsPageModule,
      ),
  },
  {
    path: "research_document",
    loadChildren: () =>
      import("./research-page/research-page.module").then(
        (mod) => mod.ResearchPageModule,
      ),
  },
  {
    path: "exceladdin",
    loadChildren: () =>
      import("./addin-page/addin-page.module").then(
        (mod) => mod.AddinPageModule,
      ),
  },
  {
    path: "reportcenter",
    loadChildren: () =>
      import("./embargo-management-page/embargo-management-page.module").then(
        (mod) => mod.EmbargoManagementPageModule,
      ),
  },
  {
    path: "labs",
    loadChildren: () =>
      import("./labs-page/labs-page.module").then((mod) => mod.LabsPageModule),
  },
  {
    path: "apitutorials",
    loadChildren: () =>
      import("./apitutorial-page/apitutorial-page.module").then(
        (mod) => mod.APITutorialPageModule,
      ),
  },
  {
    path: "biopharma",
    loadChildren: () =>
      import("./pharma-page/pharma-page.module").then(
        (mod) => mod.PharmaPageModule,
      ),
  },
  {
    path: "search-page",
    loadChildren: () =>
      import("./search-page/search-page.module").then(
        (mod) => mod.SearchPageModule,
      ),
  },
  {
    path: "xl",
    loadChildren: () =>
      import("./shared/shared.module").then((mod) => mod.SharedModule),
  },
  {
    path: "testing-stub",
    loadChildren: () =>
      import("./testing-stub-page/testing-stub-page.module").then(
        (mod) => mod.TestingStubPageModule,
      ),
  },
  {
    path: "**",
    redirectTo: "/home",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(
    private route: Router,
    private store: Store<AppState>,
  ) {
    route.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (e.url.indexOf("?next=") !== -1) {
          let finalDestination = window.location.href.split("?next=")[1];
          if (
            finalDestination.length &&
            finalDestination[finalDestination.length - 1] === "/"
          ) {
            finalDestination = finalDestination.substring(
              0,
              finalDestination.length - 1,
            );
          }
          route.navigateByUrl(decodeURIComponent(finalDestination));
        }
      }

      if (e instanceof NavigationEnd) {
        const page = e.url.split("/")[1];
        let pageName = "";
        if (e.urlAfterRedirects === "/home") {
          pageName = "home";
        } else if (page === "reporting") {
          pageName = e.url.split("/")[2];
        } else if (page === "comptables") {
          pageName = "comps";
        } else if (page === "company") {
          // old monitor page url re-directs to company page
          if (e.url.split("/")[3] && e.url.split("/")[3] !== "monitor") {
            pageName = e.url.split("/")[3];
          } else {
            pageName = page;
          }
        } else if (page.startsWith("charts")) {
          pageName = "charts";
        } else if (page === "valuation") {
          pageName = "valuation";
        } else if (page === "nav") {
          pageName = "nav";
        } else if (page === "reportcenter") {
          pageName = e.url.split("/")[2];
        } else if (page.startsWith("labs")) {
          pageName = page.split("?")[0];
        } else if (page.startsWith("apitutorials")) {
          pageName = page.split("?")[0];
        } else if (page === "industry") {
          pageName = "industry_metrics";
        } else if (page === "biopharma") {
          // old monitor page url re-directs to company page
          if (e.url.split("/")[2]) {
            pageName = `biopharma-${e.url.split("/")[2]}`;
          } else {
            pageName = page;
          }
        } else if (page === "xl") {
          pageName = e.url.split("/")[2];
        } else {
          pageName = page;
        }

        pageName = pageName === null ? "" : pageName;
        store.dispatch(new GlobalSubheaderActions.PageNameChanged(pageName));
      }
    });
  }
}
